"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResurrectionAbilityHandler = exports.ResurrectionActorAbilityFactory = exports.ResurrectionAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const EffectType_1 = require("../../core/effects/EffectType");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class ResurrectionAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Resurrection;
        this.__typeName = "Resurrection";
    }
}
exports.ResurrectionAbilityArgs = ResurrectionAbilityArgs;
let ResurrectionActorAbilityFactory = class ResurrectionActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Resurrection", "OneDeadAllies", 3);
    }
};
ResurrectionActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Resurrection")
], ResurrectionActorAbilityFactory);
exports.ResurrectionActorAbilityFactory = ResurrectionActorAbilityFactory;
let ResurrectionAbilityHandler = class ResurrectionAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        const isSelectedAllyDead = container.hasEffectOfType(selectedAlly, EffectType_1.EffectType.Death);
        if (!isSelectedAllyDead) {
            throw new Error("TARGET_NOT_DEAD");
        }
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                sequence
                    .push(core_1.AnimateCharacterVfxStepArgs.Resurrected(selectedAlly))
                    .push(new core_1.CharacterSoundEffectVfxStepArgs(selectedAlly, "resurrected"))
                    .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAlly, "chest"), "PinkGlyph"));
                container.applyBuff({
                    creatorId: ability.invokerId,
                    targetId: selectedAlly,
                    effect: new __1.ResurrectEffectArgs("Resurrection", 40),
                    duration: Duration_1.Duration.Instant,
                    sequence: sequence.pushSequence("sequential"),
                });
            }
        });
    }
};
ResurrectionAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Resurrection)
], ResurrectionAbilityHandler);
exports.ResurrectionAbilityHandler = ResurrectionAbilityHandler;
